import { Location } from './venueData';

export const createInfoWindowHTML = (location: Location): string => {
  return `
    <div class="map-info-window">
      <div class="map-info-header">
        <h3 class="map-info-title">
          <span class="map-info-icon">${location.icon}</span>
          ${location.name}
        </h3>
        <button onclick="
          if (window.currentOpenOverlay) {
            window.currentOpenOverlay.setMap(null);
            window.currentOpenOverlay = null;
          }
        " class="map-info-close">✕</button>
      </div>
      
      <div class="map-info-content">
        <p class="map-info-type">${location.type}</p>
        <p class="map-info-address">${location.address}</p>
        
        <a href="${location.url}" target="_blank" class="map-info-button">
          View in Google Maps →
        </a>
      </div>
      
      <div class="map-info-arrow"></div>
    </div>
  `;
};
